import { startApp } from './startApp';

startApp();